export default "__VITE_ASSET__DEzR09QW__"